import React from 'react'

const ClipboardIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.682 2.5H5.318c-.95 0-1.727.777-1.727 1.727v12.091h1.727V4.228h10.364V2.5zm2.59 3.455h-9.5c-.95 0-1.727.777-1.727 1.727v12.09c0 .95.778 1.728 1.728 1.728h9.5c.95 0 1.727-.777 1.727-1.727V7.682c0-.95-.777-1.727-1.727-1.727zm0 13.818h-9.5V7.682h9.5v12.09z"
      fill={props.fill ?? '#000000'}
    />
  </svg>
)

export default ClipboardIcon
